import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <a 
            href="https://recrute.leroymerlin.fr/politique-de-confidentialite" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Politique de confidentialité
          </a>
        </div>
        <div className="footer-copyright">
          {new Date().getFullYear()} Leroy Merlin France. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
